import { logout } from 'helper/comman';
import { BASE_API_URL, LOCAL_STORAGE_KEY } from 'helper/constant';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, FormGroup, Modal } from 'react-bootstrap';
import { useStore } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setLocation } from 'redux/auth/auth.action';

function SwitchServer({ children }) {
  const store = useStore();
  const history = useHistory();

  const { location: currentLocation, token } = store.getState()?.authReducer;
  const [showModalSwitchServer, setShowModalSwitchServer] = useState(false);

  const [apiServer, setApiServer] = useState(currentLocation || BASE_API_URL);
  const dispatch = useDispatch();

  const countTimer = useRef();
  const [count, setCount] = useState(0);

  async function handleSwitchServer() {
    // if (count === 4) {
    //   setShowModalSwitchServer(true);
    //   return;
    // }
    // setCount((prevState) => prevState + 1);
    // if (countTimer.current) {
    //   clearTimeout(countTimer.current);
    // }
    // countTimer.current = setTimeout(() => {
    //   setCount(0);
    // }, 300);
  }

  // async function handleSubmit() {
  //   window.localStorage.setItem(
  //     LOCAL_STORAGE_KEY.SWITCH_SERVER_DOMAIN,
  //     apiServer
  //   );
  //   dispatch(setLocation(apiServer));
  //   if (token) {
  //     await logout();
  //     history.push('/');
  //   }

  //   setShowModalSwitchServer(false);
  // }
  // async function handleForceDev() {
  //   window.localStorage.setItem(
  //     LOCAL_STORAGE_KEY.SWITCH_SERVER_DOMAIN,
  //     'https://dev-1.ringerid.com/api'
  //   );
  //   dispatch(setLocation('https://dev-1.ringerid.com/api'));
  // }
  const optionServer = [
    {
      value: BASE_API_URL,
      label: 'Production Server API',
    },
    {
      value: 'https://dev-1.ringerid.com/api',
      label: 'Dev Server API',
    },
    // {
    //   value: 'http://35.224.7.3:9000',
    //   label: 'Dev Server local API',
    // },
  ];

  return (
    <>
      {children?.({
        handleSwitchServer,
      })}
      <Modal
        size='sm'
        show={showModalSwitchServer}
        onHide={() => {
          setShowModalSwitchServer(false);
          setApiServer(currentLocation || BASE_API_URL);
        }}
        backdrop='static'
        centered
        // contentClassName='h-90'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>Change Server</h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Card border='0' className='pb-2'>
            <FormGroup tag='fieldset'>
              <legend className='fs-6'>Select server</legend>
              {optionServer.map((item) => (
                <div
                  key={item.value}
                  className='form-check  cursor-pointer mr-1'>
                  <input
                    checked={apiServer === item.value}
                    type='radio'
                    name='notify-type'
                    className='form-check-input'
                    value={item.value}
                    onChange={(e) => {
                      setApiServer(e.target.value);
                    }}
                    id={`server_${item.value}`}
                  />
                  <label
                    style={{
                      minWidth: '5px',
                    }}
                    className='form-check-label w-100 cursor-pointer'
                    htmlFor={`server_${item.value}`}>
                    {item.label}
                  </label>
                </div>
              ))}
            </FormGroup>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <div className='submit-button'>
            <Button
              // onClick={handleSubmit}
              variant='primary'
              className='d-flex align-items-center'>
              {/* {isLoadingSubmitImport && (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )} */}
              <span
                style={{
                  textTransform: 'initial',
                }}
                className='ps-1'>
                {token ? 'Switch and logout' : 'Switch server'}
              </span>
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SwitchServer;
